import { Button } from 'antd';
import styled from 'styled-components';
import { COLOR, RADIUS } from '../../../constants/theme';

const PrimaryButton = styled(Button)`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 48px;
    padding: 0 24px;
    border: none;
    border-radius: ${RADIUS.md};
    background: ${COLOR.primary};
    color: ${COLOR.surface};
    font-size: 15px;
    font-weight: 700;
    box-shadow: none;

    &:hover,
    &:focus {
      background: ${COLOR.primaryDark};
      color: ${COLOR.surface};
    }

    &:disabled {
      background: ${COLOR.mutedBackground};
      color: ${COLOR.textMuted};
    }
  }
`;

export default PrimaryButton;
